export namespace RideMonitoringErrorConstants {
  export const OPERATION_ALERT_ALREADY_ASSIGNED: RegExp = /Operation alert has already been assigned/;
  export const OPERATION_ALERT_NOT_ASSIGNED: RegExp = /Operations alert is not assigned/;
  export const OPERATION_ALERT_ACTION_FORBIDDEN: RegExp = /This action is forbidden/;
  export const OPERATION_ALERT_CANNOT_RESOLVE_RESOLVED_ALERT: RegExp = /Cannot resolve an already resolved OperationsAlert/;
}
